/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, ElementRef, HostListener, inject, output } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[cmg-input-remove-spaces]',
})
export class CmgInputRemoveSpacesDirective {
  private readonly _el = inject(ElementRef);
  private readonly _ngControl = inject(NgControl);

  readonly ngModelChange = output();

  @HostListener('blur') onBlur() {
    this._ngControl.control.setValue(this._el.nativeElement.value.replace(/\s+/g, ''));
  }

  @HostListener('keyup')
  onKeyup() {
    this._ngControl.control.setValue(this._el.nativeElement.value.replace(/\s+/g, ''));
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event) {
    if (event.keyCode === 32) {
      event.preventDefault();
    }
  }
}
